import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import styles from "./index.module.scss";

type IProps = Immutable<{
    items: templates.LandingPageTemplate["promo_bar"];
    className?: string;
}>;

/**
 * The ``get_solo PromoSettings`` promo bar shared by the LandingPage and
 * ProductDisplayPage templates. The outer wrapper always renders; an
 * empty ``items`` list reproduces an empty loop. ``mobile_inner_html`` is
 * built server-side (``react_shell.build_promo_bar_items``) because it
 * interleaves raw ``|safe`` copy with a SHOP NOW anchor as flat siblings.
 */
export const PromoBar = (props: IProps): React.JSX.Element => (
    <div className={concatClassNames([styles.promoBar, props.className])}>
        {props.items.map((item, i) => (
            <React.Fragment key={i}>
                <div
                    className={styles.promoBarCopy}
                    dangerouslySetInnerHTML={{ __html: item.copy_html }}
                />
                <div
                    className={styles.promoBarCopyMobile}
                    dangerouslySetInnerHTML={{
                        __html: item.mobile_inner_html,
                    }}
                />
                <div className={styles.promoBarButton}>
                    <a
                        className={styles.promoBarButtonLink}
                        href={item.shop_now_url}
                    >
                        <p>SHOP NOW</p>
                    </a>
                    <div className={styles.promoBarButtonDiagonal} />
                </div>
            </React.Fragment>
        ))}
    </div>
);
